<template>
  <div class="Lifelayer_main_parent_container aside element-to-hide" id="assidemenu">
    <div class="lifelayer-close-box">
      <img src="../assets/imagesFolder/close-svgrepo-com.svg" class="lifelayer-close-icon" alt="Close Icon" />
    </div>
    <div class="Lifelayer-main grid-container">
      <div class="lifelayer-sidebar-left column column-1" ref="column1" @mouseenter="enableScroll('column1')"
        @mouseleave="resetScroll" @scroll="handleScroll('column1')">
        <img class="lifelayer-menu-icon" src="../assets/svgFolder/menu-svgrepo-com (1).svg" height="30px" />
        <div class="lifelayer-sidebar" id="myElement" :class="{ open: isOpen }">
          <div class="radio1" style="z-index: 9999">
            <router-link v-if="currentRolePath" :to="currentRolePath">
              <div class="profile_picture_container" v-if="userData">
                <img class="video1" id="sidebar-image" :src="userData.thumbnailImageUrl || fallbackImage" alt="Avatar" />
              </div>
            </router-link>
          </div>

          <div class="lifelayer-icon-container" :class="{ active: activeContainer === index }"
            @click="setActiveContainer(index)">
            <div class="lifelayer-sidebar-icon" data-tooltip="Dashboard">
              <div class="sidebar-icon-container">
                <img class="sidebar-icon" src="../assets/dashboard/icons/dashboard-3-svgrepo-com.svg" alt="Dashboard" />
              </div>
            </div>
            <div class="lifelayer-tooltip">
              <div class="lifelayer-tooltip-text">Dashboard</div>
              <div class="lifelayer-sidebar-dropdown" :style="{
                position:
                  index >= sidebarItems.length - 2 ? 'absolute' : 'static',
              }">
                <div class="lifelayer-dropdown-item" to="/userdashboard"
                  :class="{ active: activeDropdownItem === Dashbaord }">
                  <router-link v-if="this.$store.getters.hasuserdetails?.role === 'admin'" to="/admin_dashboard">
                    <a href="javascript:void(0)" class="languageChange dasboard_sidebar"
                      id="admin_dashboard">Dashboard</a>
                  </router-link>
                  <router-link v-else-if="
                    this.$store.getters.hasuserdetails?.role === 'customer'
                  " to="/userDashboard">
                    <a href="javascript:void(0)" class="languageChange dasboard_sidebar"
                      id="patient_dashboard">Dashboard</a>
                  </router-link>
                  <router-link v-else-if="
                    this.$store.getters.hasuserdetails?.role === 'vendor'
                  " to="/vendor_dashboard">
                    <a href="javascript:void(0)" class="languageChange dasboard_sidebar"
                      id="vendor_dashboard">Dashboard</a>
                  </router-link>
                  <router-link v-else-if="
                    this.$store.getters.hasuserdetails?.role === 'doctor'
                  " to="/userDashboard">
                    <a href="javascript:void(0)" class="languageChange dasboard_sidebar"
                      id="doctor_dashboard">Dashboard</a>
                  </router-link>
                  <router-link v-else-if="
                    this.$store.getters.hasuserdetails?.role === 'student'
                  " to="/userDashboard">
                    <a href="javascript:void(0)" class="languageChange dasboard_sidebar"
                      id="student_dashboard">Dashboard</a>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div v-for="(item, index) in sidebarItems" :key="item.tooltip" class="lifelayer-icon-container"
            :class="{ active: activeContainer === index }" @click="setActiveContainer(index)">
            <!-- @mouseenter="showTooltip(index)" @mouseleave="hideTooltip"> -->
            <div class="lifelayer-sidebar-icon" :data-tooltip="item.tooltip">
              <div class="sidebar-icon-container">
                <img class="sidebar-icon" :src="item.iconSrc" :alt="item.tooltip" />
              </div>
            </div>

            <div class="lifelayer-tooltip">
              <div class="lifelayer-tooltip-text">{{ item.tooltipText }}</div>
              <div class="lifelayer-sidebar-dropdown" :style="{
                position:
                  index >= sidebarItems.length - 2 ? 'absolute' : 'static',
              }">
                <div v-for="option in item.dropdownOptions" :key="option.subMenu" class="lifelayer-dropdown-item"
                  @click="navigateTo(option.url)" :class="{ active: activeDropdownItem === option.subMenu }">
                  {{ option.subMenu }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column column-2" ref="column2" @mouseenter="enableScroll('column2')" @mouseleave="resetScroll">
        <div class="page" v-for="(page, index) in pages" :key="index">
          <img :src="page" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoggedIn: this.$store.getters.isLoggedIn,
      companyImage: this.$store.getters.companyImage,
      userData: {},
      activeContainer: null,
      activeDropdownItem: null,
      tooltipVisible: false,
      fetchdata: null,
      modifiedSidebar: [],
      mysidebar: "",
      roleRoutes: {
        admin: "/admin",
        customer: "/customer",
        doctor: "/doctor",
        student: "/student",
        paramedics: "/paramedics",
        teacher: "/teacher",
        vendor: "/vendor",
      },
      fallbackImage: require("../assets/profile/img/userProfile.jpg"),
      sidebarItems: [
        
        {
          tooltip: "Health Tracker",
          tooltipText: "Health Tracker",
          iconSrc: require("../assets/svgFolder/healthtracker.png"),
          dropdownOptions: [
            { subMenu: "Add Health Details", url: "newinputfield" },
            // { subMenu: "Health Moniter", url: "view-myhealth-record" },
            { subMenu: "Add Details", url: "addthealth" },
            { subMenu: "Health Moniter", url: "examination" },
            { subMenu: "Patient Health Moniter", url: "patienthealthtracker" },
            { subMenu: "Health Result", url: "resulthealthtraker" },
            { subMenu: "Health Notification", url: "healthnotification" },
            // { subMenu: "Fill Details", url: "prescription-template" },
            { subMenu: "Fill Health Details", url: "Coming_Soon" },
          ],
        },
        // {
        //   tooltip: "Text Editor",
        //   tooltipText: "Text Editor",
        //   iconSrc: require("../assets/svgFolder/editoricon.png"),
        //   dropdownOptions: [{ subMenu: "Text Editor", url: "newEditor" }],
        // },

        ...(["doctor"].includes(this.$store.getters.hasuserdetails.role)
          ? [
            {
              tooltip: "OCR ",
              tooltipText: "OCR ",
              iconSrc: require("../assets/svgFolder/ocr_icon.png"),
              dropdownOptions: [
                {
                  subMenu: " My OCR Report",
                  url: "ocr_report",
                },
                // {
                //   subMenu: "Create Template",
                //   url: "prescription-template",
                // },
              ],
            },
          ]
          : []),

        // ...(["doctor"].includes(this.$store.getters.hasuserdetails.role)
        //   ? [
        //     {
        //       tooltip: "Medical CRM",
        //       tooltipText: "Medical CRM",
        //       iconSrc: require("@/assets/svgFolder/crm.svg"),
        //       dropdownOptions: [
        //         { subMenu: "Add Customer Data", url: "add_customer_data" },
        //         {
        //           subMenu: "Select Invitation Data",
        //           url: "select_data_for_invitation",
        //         },
        //       ],
        //     },
        //   ]
        //   : []),

        //         {
        //   tooltip: "Advertisement",
        //   tooltipText: "Advertisement",
        //   iconSrc: require("../assets/svgFolder/advertisement-svgrepo.svg"),
        //   dropdownOptions: [
        //     ...(
        //       this.$store.getters.hasuserdetails.role !== "admin"
        //         ? [{ subMenu: "Create Advertisement", url: "advertisement_management" }]
        //         : []
        //     ),
        //     {
        //       subMenu: "Advertisement Dashboard",
        //       url: "advertisement_management_dashboard",
        //     },
        //   ],
        // },
        ...(["admin", "business"].includes(
          this.$store.getters.hasuserdetails.role
        )
          ? [
            {
              tooltip: "Advertisement",
              tooltipText: "Advertisement",
              iconSrc: require("../assets/svgFolder/advertisement-svgrepo.svg"),
              dropdownOptions: [
                {
                  subMenu: "Create Advertisement",
                  url: "advertisement_management",
                },
                {
                  subMenu: "Advertisement Dashboard",
                  url: "advertisement_management_dashboard",
                },
              ],
            },
          ]
          : []),


        // {
        //   tooltip: "Home",
        //   tooltipText: "Appoinment",
        //   iconSrc: require("../assets/svgFolder/appointmenticons.png"),
        //   dropdownOptions: [
        //     ...(this.$store.getters.hasuserdetails.role == "doctor"
        //       ? [
        //         { subMenu: "Appoinment Block", url: "appointmentBlock" },
        //         { subMenu: "Symtoms Report", url: "symtomsReports" },
        //       ]
        //       : []),
        //     {
        //       subMenu: "Patient Appointment Block",
        //       url: "patientAppointmentBlock",
        //     },
        //   ],
        // },
        // {
        //   tooltip: "Home",
        //   tooltipText: "Doctor Appointment",
        //   iconSrc:
        //     this.$store.getters.hasuserdetails.role === "doctor"
        //       ? require("../assets/universalIcons/doctor.svg")   // doctor ka icon
        //       : require("../assets/svgFolder/appointmenticons.png"), // patient ka icon
        //   dropdownOptions: [
        //     ...(this.$store.getters.hasuserdetails.role === "doctor"
        //       ? [
        //         { subMenu: "Appoinment Block", url: "appointmentBlock" },
        //         { subMenu: "Symtoms Report", url: "symtomsReports" },
        //       ]
        //       : []),
        //     {
        //       subMenu: "Patient Appointment Block",
        //       url: "patientAppointmentBlock",
        //     },
        //   ],
        // },
        // {
        //   tooltip: "Home",
        //   tooltipText:
        //     this.$store.getters.hasuserdetails.role === "doctor"
        //       ? "Doctor Appointment"
        //       : "Patient Appointment", // 👈 role ke hisaab se text
        //   iconSrc:
        //     this.$store.getters.hasuserdetails.role === "doctor"
        //       ? require("../assets/universalIcons/doctor.svg") // doctor ka icon
        //       : require("../assets/universalIcons/patient.svg"), // patient ka icon
        //   dropdownOptions: [
        //     ...(this.$store.getters.hasuserdetails.role === "doctor"
        //       ? [
        //         { subMenu: "Appoinment Block", url: "appointmentBlock" },
        //         { subMenu: "Symtoms Report", url: "symtomsReports" },
        //       ]
        //       : []),
        //     {
        //       subMenu: "Patient Appointment Block",
        //       url: "patientAppointmentBlock",
        //     },
        //   ],
        // },
        {
          tooltip: "Home",
          tooltipText:
            this.$store.getters.hasuserdetails.role === "doctor"
              ? "My Planner"
              : "Patient Appointment",

          iconSrc:
            this.$store.getters.hasuserdetails.role === "doctor"
              ? require("../assets/universalIcons/doctor.svg")
              : require("../assets/universalIcons/patient.svg"),

          dropdownOptions:
            this.$store.getters.hasuserdetails.role === "doctor"
              ? [{ subMenu: "My Planner | Calender", url: "doctor-calender-setup" },
              { subMenu: "My Daybook | Appointments", url: "my-appointment-daybook" },
              { subMenu: "My Referral Patients | Customers", url: "referralBlock" },

              ]
              : [
                { subMenu: "Patient Appointment Block", url: "patientAppointmentBlock" },
                { subMenu: "Patient Referral Block", url: "referralBlock" },
              ],
        },

        ...(
  ["doctor", "student", "paramedics"].includes(this.$store.getters.hasuserdetails.role)
    ? [
        {
          tooltip: "calender",
          tooltipText: " My Job Board",
          iconSrc: require("../assets/svgFolder/search-minus-svgrepo-com.svg"),
          dropdownOptions: [
            { subMenu: "Show All Jobs", url: "showJobsPage" },
            { subMenu: "Applied & Saved Jobs", url: "savedandAppliedJobs" },
            { subMenu: "Search Job", url: "searchJob" },
            { subMenu: "Show Top Jobs", url: "salaryguide" },
          ],
        },
      ]
    : []
),

        {
          tooltip: "Medical Education",
          tooltipText: "Medical Education",
          iconSrc: require("../assets/universalProfileIcons/education.svg"),
          dropdownOptions: [
            { subMenu: "Available Courses", url: "courses" },
            { subMenu: "Create Course", url: "uploadContent" },
            { subMenu: "Create Chapter", url: "uploadChapter" },
            { subMenu: "Create Topics", url: "anotherchapter" },
            { subMenu: "My Medical Courses", url: "teacherscourses" },
            { subMenu: "Learner's Page", url: "lernersDashboard" },
            

          ],
        },

        ...(["business"].includes(this.$store.getters.hasuserdetails.role)
          ? [
            {
              tooltip: "Home",
              tooltipText: "Post Job",
              iconSrc: require("../assets/svgFolder/newspaper-6-svgrepo-com.svg"),
              dropdownOptions: [
                { subMenu: "Dashboard", url: "JobDashboard" },
                { subMenu: "Post Job", url: "postFreeJobs" },
              ],
            },
          ]
          : []),

       {
  tooltip: "Home",
  tooltipText: "Blog",
  iconSrc: require("@/assets/svgFolder/blog.svg"),
  dropdownOptions: [
    ...(this.$store.getters.hasuserdetails.role === "doctor"
      ? [{ subMenu: "Create Blogs", url: "create-blog" }]
      : []),

    { subMenu: "All Blogs", url: "blogs" },
    { subMenu: "Knowledge Base", url: "knowledgebase" },

    ...(this.$store.getters.hasuserdetails.role === "doctor"
      ? [
          { subMenu: "My Blogs", url: "my-blogs" },
          { subMenu: "Drafts", url: "my-blogs/drafts" },
        ]
      : []),
  ],
},
        {
          tooltip: "Home",
          tooltipText: "Family Management",
          iconSrc: require("../assets/svgFolder/family.svg"),
          dropdownOptions: [
            { subMenu: "Manage Family", url: "FamilyManagement" },
            { subMenu: "Family Plans", url: "familyPlans" },
          ],
        },

        {
          tooltip: "Home",
          tooltipText: "Customer Handling",
          iconSrc: require("../assets/svgFolder/customer-handle.svg"),
          dropdownOptions: [
            ...(this.$store.getters.hasuserdetails.role === "doctor"
              ? [
                { subMenu: "My Questionnaire", url: "questionnaire" },
                { subMenu: "Z Tracker", url: "Z_Tracker" },
              ]
              : []),
            {
              subMenu: "Letter & Draft",
              url: "templateSelectionPage",
            },
          ],
        },

       ...(this.$store.getters.hasuserdetails.role === "doctor"
  ? [
      {
        tooltip: "My Identity",
        tooltipText: "My Identity",
        iconSrc: require("../assets/svgFolder/podcast.svg"),
        dropdownOptions: [
          { subMenu: "Audio Podcast", url: "Coming_Soon" },
          { subMenu: "Video Podcast", url: "create-public-podcast" },
        ],
      },
    ]
  : []),
        {
          tooltip: "My Portfolio",
          tooltipText: "My Portfolio",
          iconSrc: require("../assets/svgFolder/portfolio.svg"),
          dropdownOptions: [
            
            { subMenu: "Coins", url: "coinsDashboard" },
            { subMenu: "Credits", url: "my-credits" },
          ],
        },
        {
  tooltip: "Home",
  tooltipText: "Article",
  iconSrc: require("@/assets/svgFolder/article.svg"),
  dropdownOptions: [
    ...(this.$store.getters.hasuserdetails.role === "doctor"
      ? [{ subMenu: "Create Articles", url: "createArticle" }]
      : []),

    { subMenu: "All Articles", url: "allArticleCards" },

    ...(this.$store.getters.hasuserdetails.role === "doctor"
      ? [{ subMenu: "My Articles", url: "myArticleCards" }]
      : []),
  ],
},

        {
          tooltip: "Storage ",
          tooltipText: "Storage Services",
          iconSrc: require("../assets/svgFolder/storage.svg"),
          dropdownOptions: [
            { subMenu: "Storage Services", url: "storage" },
           
          ],
        },
        {
          tooltip: "calender",
          tooltipText: "Booking",
          iconSrc: require("../assets/svgFolder/booking.svg"),
          dropdownOptions: [
            { subMenu: "Event Scheduler", url: "Coming_Soon" },
            { subMenu: "Hotel Booking", url: "Coming_Soon" },
            { subMenu: "Seat Booking", url: "Coming_Soon" },
          ],
        },
        {
          tooltip: "calender",
          tooltipText: "Send Invitation",
          iconSrc: require("../assets/svgFolder/send_invitation.svg"),
          dropdownOptions: [
            { subMenu: "Send Invitation", url: "send-invitation" },
          ],
        },
      ],
    };
  },

  computed: {
    role() {
      return this.$store.getters.hasuserdetails?.role || "";
    },
    currentRolePath() {
      const details = this.$store.getters.hasuserdetails;
      if (details.candidateEmail && this.role === "doctor") {
        return "/company-doctor";
      }
      return this.roleRoutes[this.role] || null; // null means no match
    },
  },
  methods: {
    openHTMLProject() {
      const url = "http://192.168.1.38:5500/src/Dviewer/html/start.html";
      window.open(url, "_blank");
    },

    // fetch userImage
    async fetchUserImage() {
      try {
        // const user_id = this.$store.getters.hasuserdetails._id;
        const user_id = this.$store.getters.hasuserdetails?._id;

        console.log("User Data:", this.$store.getters.hasuserdetails);
        if (!user_id) {
          console.error("User ID is not available.");
          return;
        }
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}auth/getimage/${user_id}`,
          { withCredentials: true }
        );
        this.userData = response.data;
        console.log("Fetch Image Successfully", this.userData);
      } catch (err) {
        console.log("Error to fetch image", err);
      }
    },

    setActiveContainer(index) {
      this.activeContainer = index;
    },
    setActiveDropdownItem(subMenu) {
      this.activeDropdownItem = subMenu;
    },
    navigateTo(url) {
      this.$router.push({ path: `/${url}` });
    },
    enableScroll(column) {
      if (column === "column1") {
        this.$refs.column1.style.overflowY = "auto";
        this.$refs.column2.style.overflowY = "hidden";
      } else if (column === "column2") {
        this.$refs.column2.style.overflowY = "auto";
        this.$refs.column1.style.overflowY = "hidden";
      }
    },
    resetScroll() {
      this.$refs.column1.style.overflowY = "auto";
      this.$refs.column2.style.overflowY = "auto";
    },
    showTooltip() {
      // console.log("mouseenter");

      this.tooltipVisible = true;
    },
    hideTooltip() {
      // console.log("mouseleave");

      this.tooltipVisible = false;
    },
    handleScroll() {
      this.tooltipVisible = false;
    },
  },

  created() {
    // this.fetchCompanyData();
  },

  mounted() {
    this.fetchUserImage();
    // ✅ Custom event listener for image update
    window.addEventListener("profileImageUpdated", this.fetchUserImage);
    setTimeout(() => {
      const icons = this.$el.querySelectorAll(".lifelayer-icon-container");

      icons.forEach((container, index) => {
        const icon = container.querySelector(".lifelayer-sidebar-icon");
        const tooltip = container.querySelector(".lifelayer-tooltip");
        const dropdown = container.querySelector(".lifelayer-sidebar-dropdown");

        icon.addEventListener("mouseenter", () => {
          const rect = icon.getBoundingClientRect();
          tooltip.style.top = `${rect.top}px`;
          tooltip.style.display = "block";
        });

        icon.addEventListener("mouseleave", () => {
          setTimeout(() => {
            if (!tooltip.matches(":hover") && !dropdown.matches(":hover")) {
              tooltip.style.display = "none";
              dropdown.style.display = "none";
            }
          }, 10);
        });

        tooltip.addEventListener("mouseenter", () => {
          dropdown.style.display = "block";
        });

        tooltip.addEventListener("mouseleave", () => {
          dropdown.style.display = "none";
          tooltip.style.display = "none";
        });
        // Use Vue's nextTick to ensure the DOM is fully rendered
        this.$nextTick(() => {
          const menuItems = document.querySelectorAll(".menu-item");
          if (menuItems.length > 0) {
            menuItems.forEach(function (menuItem) {
              menuItem.addEventListener("mouseover", function () {
                menuItems.forEach(function (item) {
                  item.classList.remove("active");
                });
                menuItem.classList.add("active");
              });
            });
          } else {
            console.log("No menu items found.");
          }
        });

        document.getElementById("myElement").addEventListener("scroll", () => {
          container.querySelector(".lifelayer-sidebar-dropdown").style.display =
            "none";
          container.querySelector(".lifelayer-tooltip").style.display = "none";
        });

        dropdown.addEventListener("mouseleave", () => {
          tooltip.style.display = "none";
          dropdown.style.display = "none";
        });
        // dropdown.addEventListener('scroll', () => {
        //     tooltip.style.display = 'none';
        //     dropdown.style.display = 'none';
        // });

        if (index >= icons.length - 2) {
          dropdown.style.position = "absolute";
          dropdown.style.bottom = "100%";
        }
      });

      const menuIcons = this.$el.querySelectorAll(".lifelayer-menu-icon");
      menuIcons.forEach((icon) => {
        icon.addEventListener("click", () => {
          const sidebar = this.$el.querySelector(".lifelayer-sidebar");
          sidebar.style.display = "block";

          const closeIcons = this.$el.querySelectorAll(".lifelayer-close-icon");
          closeIcons.forEach((closeIcon) => {
            closeIcon.style.display = "inline-block";
            closeIcon.style.position = "absolute";
            closeIcon.style.zIndex = "9999";

            closeIcon.addEventListener("click", () => {
              sidebar.style.display = "none";
              closeIcon.style.display = "none";
            });
          });
        });
      });

      const dropdownItems = this.$el.querySelectorAll(
        ".lifelayer-dropdown-item"
      );
      dropdownItems.forEach((item) => {
        item.addEventListener("click", () => {
          dropdownItems.forEach((i) => i.classList.remove("active"));
          item.classList.add("active");
        });
      });
    }, 2000);
  },
  unmounted() {
    window.removeEventListener("profileImageUpdated", this.fetchUserImage);
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.lifelayer-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 60px;
  height: 100%;
  color: black;
  overflow-y: auto;
  /*z-index: 9999999999999;*/
  z-index: 99;
  background-color: white;
}

.lifelayer-sidebar::-webkit-scrollbar {
  display: none;
}

.lifelayer-menu-icon {
  position: absolute;
  font-size: 25px;
  margin-left: 10px;
  display: none;
}

.lifelayer-close-icon {
  font-size: 25px;
  display: none;
  margin-left: -40px;
}

.lifelayer-close-box {
  float: right;
}

.lifelayer-sidebar-icon {
  padding: 2px;
  cursor: pointer;
  text-align: center;
}

.lifelayer-tooltip {
  position: fixed;
  background: #6b0a23;
  color: white;
  padding: 0px 0px 0px 0px;
  display: none;
  width: 200px;
  font-size: 10px;
  margin-left: 60px !important;
}

.lifelayer-tooltip-text {
  padding: 10px 0px 9.5px 0px;
  font-weight: 600;
  font-size: 12px;
  height: 35px;
}

.lifelayer-icon-container {
  position: relative;
  z-index: 99999999;
}

.lifelayer-icon-container:hover {
  background-color: #6b0a23 !important;
  color: white !important;
}

.lifelayer-sidebar-dropdown {
  display: none;
  position: absolute;
  background: #cdf4fb;
  color: black;
  font-weight: 400;
  margin-left: 0px !important;
  padding: 5px 0px 0px 0px;
  left: 45px;
  width: 200px;
  height: 180px !important;
  transition: 1s ease-in-out;
}

.lifelayer-sidebar-dropdown i {
  position: absolute;
  color: #a5a0a0;
  right: 40px;
  bottom: 5px;
}

.lifelayer-dropdown-item {
  padding: 13px;
  font-size: 12px;
  z-index: 999;
}

.lifelayer-dropdown-item:hover {
  color: white;
}

.lifelayer-icon-container:nth-child(1) {
  margin-top: 1000px;
}

.lifelayer-icon-container {
  position: relative;
  font-size: 24px;
  top: 60px;
  margin: 0px 0px 10px 0px;
  z-index: -999 !important;
}

.lifelayer-icon-container.active {
  background-color: #6b0a23 !important;
  color: white;
  border-radius: 0 !important;
}

.lifelayer-icon-container.active .sidebar-icon {
  filter: invert(100%);
  border-radius: 0px !important;
}

/* akash changes start here */

/* .lifelayer-icon-container .lifelayer-sidebar-icon {
  padding-bottom: 20px;
} */
.lifelayer-icon-container .lifelayer-sidebar-icon {
  padding: 2.5px 10px;
  height: 35px;
}

/* akash changes end here */

.lifelayer-dropdown-item:hover {
  cursor: pointer;
  color: black;
  background-color: rgb(165, 214, 234);
  transition: 0.3s;
}

.lifelayer-dropdown-item.active {
  background-color: white;
  color: black;
  border-radius: 0px !important;
}

.sidebar-icon.active {
  /*background-color: #6b0a23;*/
  color: white;
}

/* akash changes start here */

/* .sidebar-icon-container {
   background: #d50909; pehle se hi comment thi ye line
  height: 20px;
  width: 20px;
  margin: auto;
} */

.sidebar-icon-container {
  /* background: #d50909; */
  /* height: 20px; */
  width: 20px;
  margin: auto;
}

/* akash changes end here */

.lifelayer-sidebar-icon:hover .sidebar-icon {
  filter: invert(100%);
}

.sidebar-icon-container .sidebar-icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sidebar-icon {
  fill: white;
}

.lifelayer-icon-container:nth-last-child(-n + 2) .lifelayer-sidebar-dropdown {
  bottom: 100%;
  top: auto;
  left: 0px;
  margin-bottom: 0px;
}

.lifelayer-sidebar-dropdown {
  height: 200px;
  overflow-y: scroll;
  scrollbar-width: thin;
}

.lifelayer-profile-icon {
  height: 50px;
  width: 50px;
  border-radius: 3px;
  position: fixed;
  /* z-index: 999; */
  padding: 3px;
}

.page {
  /* height: 100%; */
  width: 100%;
}

.page img {
  width: 100%;
}

.lifelayer-profile-icon img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.column-1::-webkit-scrollbar {
  display: none;
}

@media (max-width: 400px) {

  .page1,
  .page2,
  .page3 {
    width: 100%;
    height: 300px;
  }

  .page1 img,
  .page2 img,
  .page3 img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  .lifelayer-sidebar-dropdown,
  .lifelayer-tooltip {
    width: 150px;
  }

  .lifelayer-tooltip-text {
    font-weight: 500;
  }
}

.grid-container {
  height: 100vh;
}

.column-2::-webkit-scrollbar {
  display: none !important;
}

.column {
  overflow-y: auto;
  max-height: 100vh;
}

.radio1 {
  position: fixed;
  height: 46px;
  width: 60px;
}

.radio1 img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  cursor: pointer;
  object-fit: cover;
}

.profile_picture_container {
  position: relative;
  height: 100%;
  width: 100%;

  background-color: white;
}

.profile_picture_container .video1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dasboard_sidebar {
  color: black !important;
  text-decoration: none;
}

/* Mobile view */
@media (max-width: 768px) {
  .lifelayer-sidebar {
    top: 0;
    width: 60px;
    left: -100px;
    z-index: 9999;
    transition: all 0.5s;
    height: 1000px !important;
    /* background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.4)
    ); second color*/
    background-color: white;
  }

  .lifelayer-sidebar.open {
    left: 0px;
    /* background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.4)
    ); second color*/
    background-color: white;
  }

  .profile_picture_container {
    /* background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.4)
    ); second color*/
    background-color: white;
  }

  .radio1 {
    height: 52px;
  }
}
</style>
